import { render, staticRenderFns } from "./ModalBlock.vue?vue&type=template&id=051c715a&scoped=true"
import script from "./ModalBlock.vue?vue&type=script&lang=js"
export * from "./ModalBlock.vue?vue&type=script&lang=js"
import style0 from "./modal-block.scss?vue&type=style&index=0&id=051c715a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c715a",
  null
  
)

export default component.exports